import type { Locale } from '../i18n/t.js';

export type Skill = 'recognition' | 'counting' | 'addition' | 'subtraction';

export const SKILLS: readonly Skill[] = ['recognition', 'counting', 'addition', 'subtraction'];

export interface LevelState {
  level: number;
  badSessionsAtLevel: number;
}

export interface Attempt {
  skill: Skill;
  level: number;
  correct: boolean;
  timestamp: number;
}

export interface Profile {
  schemaVersion: 1;
  locale: Locale | null;
  skills: Record<Skill, LevelState>;
  history: Record<Skill, Attempt[]>;
}

export const PROFILE_STORAGE_KEY = 'learn-numbers:profile:v1';
export const PROFILE_CORRUPT_KEY = 'learn-numbers:profile:v1:corrupt';
export const HISTORY_RETENTION_PER_SKILL = 100;

export function defaultProfile(): Profile {
  const skills: Record<Skill, LevelState> = {
    recognition: { level: 1, badSessionsAtLevel: 0 },
    counting: { level: 1, badSessionsAtLevel: 0 },
    addition: { level: 1, badSessionsAtLevel: 0 },
    subtraction: { level: 1, badSessionsAtLevel: 0 },
  };
  const history: Record<Skill, Attempt[]> = {
    recognition: [],
    counting: [],
    addition: [],
    subtraction: [],
  };
  return {
    schemaVersion: 1,
    locale: null,
    skills,
    history,
  };
}
